import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { translator } from 'mage-i18n';
import { withConfiguredFlow } from 'moet-core';

import {
  getMerchantCountryKey,
  getMerchant,
  getUserMerchantId,
  getExtraContextProps,
  isNewSplitLayout,
  merchantRegion,
  getMerchantCountryConfig,
  getMerchantRegionConfig,
} from '@/selectors/merchant';
import { isWidget } from '@/selectors/widget';
import { TOP_BAR_HEIGHT } from '@/constants/styles';
import ContextWrappedTopBar from '@/components/ContextWrappedTopBar';
import { FLOW_STEP_PATHS, FLOW_THEMES } from '@/constants';

import { getFlowConfig } from './configs';

const hideTopBar = [
  FLOW_STEP_PATHS.APPLICATION_CHECKING_PATH,
  FLOW_STEP_PATHS.APPLICATION_SUCCESS_PATH,
];

const MemoizedContainer = React.memo(
  ({ Container, productParam, ...props }) => <Container {...props} productParam={productParam} />,
  (oldProps = {}, newProps = {}) => {
    const {
      Container: oldContainer = {},
      merchant: { id: oldMid } = {},
      location: { pathname: oldPathname } = {},
    } = oldProps;
    const { Container = {}, merchant: { id: mid } = {}, location: { pathname } = {} } = newProps;

    return (
      oldContainer.displayName === Container.displayName &&
      oldMid === mid &&
      oldPathname === pathname
    );
  },
);

MemoizedContainer.displayName = 'MemoizedContainer';
MemoizedContainer.propTypes = {
  location: PropTypes.object.isRequired,
  merchant: PropTypes.object.isRequired,
  Container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  productParam: PropTypes.string,
};

const FlowApp = props => {
  const { animation, isNewSplitLayout, productParam, ...passDownProps } = props;
  const shouldShowSteps =
    !isNewSplitLayout && !hideTopBar.includes(get(props, 'match.params.steps'));

  return (
    <>
      {shouldShowSteps && <ContextWrappedTopBar />}
      <div style={{ marginTop: !props.isWidget || isNewSplitLayout ? 0 : TOP_BAR_HEIGHT * 0.8 }}>
        <MemoizedContainer {...passDownProps} productParam={productParam} />
      </div>
    </>
  );
};

FlowApp.propTypes = {
  country: PropTypes.string.isRequired,
  isNewSplitLayout: PropTypes.bool.isRequired,
  isWidget: PropTypes.bool.isRequired,
  merchant: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  animation: PropTypes.object,
  Container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  productParam: PropTypes.string,
};

export default compose(
  connect(state => ({
    flowConfig: getFlowConfig(state),
    country: getMerchantCountryKey(state),
    countryConfig: getMerchantCountryConfig(state),
    isNewSplitLayout: isNewSplitLayout(state),
    isWidget: isWidget(state),
    merchant: getMerchant(state),
    region: merchantRegion(state),
    regionConfig: getMerchantRegionConfig(state),
    mid: getUserMerchantId(state),
    t: translator(state),
    extraContextProps: getExtraContextProps(state),
  })),
  withConfiguredFlow(FLOW_THEMES),
)(FlowApp);
